<template>
  <div>
    <div class="row">
      <div class="col-md">
        <div class="portlet">
          <div class="portlet-head">
            <h3><i class="fas fa-file-invoice"></i> Lista wzorów dokumentów</h3>
            <div v-if="hasAccess('documentsEdit')">
              <b-button @click="addDocument()" variant="outline-primary">
                <i class="fas fa-plus"></i> Dodaj wzór dokumentu
              </b-button>
            </div>
          </div>
          <div class="portlet-body">
            <b-table
              class="table table-sm table-list table-mobile"
              id="documents_list"
              ref="documents_table"
              :fields="fields"
              :busy.sync="isBusy"
              :items="getDocuments"
              stacked="xl"
            >
              <template v-slot:table-busy>
                <TableSpiner />
              </template>
              <template v-slot:cell(name)="data">
                {{ data.item.name }}<br />
              </template>
              <template v-slot:cell(size)="data">
                {{ humanFileSize(data.item.size) }}
              </template>
              <template v-slot:cell(created_at)="data">
                {{ data.item.created_at | date }}<br />
                <small>{{ data.item.created_by_fullname }}</small>
              </template>

              <template v-slot:cell(updated_at)="data">
                <span v-if="data.item.updated_by_fullname">
                  {{ data.item.updated_at | date }}<br />
                  <small>{{ data.item.updated_by_fullname }}</small>
                </span>
                <span v-else> - </span>
              </template>

              <template v-slot:cell(download)="data">
                <button
                  @click="download(data.item)"
                  class="btn btn-sm btn-rounded btn-outline-primary"
                >
                  <i class="fas fa-download"></i>
                </button>
              </template>

              <template v-slot:cell(options)="data">
                <b-dropdown no-caret right variant="light" class="btn-rounded">
                  <template v-slot:button-content>
                    <i class="fas fa-ellipsis-v"></i>
                  </template>
                  <b-dropdown-item-button @click="editDocument(data.index)"
                    >Edytuj</b-dropdown-item-button
                  >
                  <template v-if="hasAccess('documentDelete')">
                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item-button
                      @click="confirmRemove(data.index)"
                      class="danger"
                    >
                      <i class="fas fa-trash-alt"></i> Usuń
                    </b-dropdown-item-button>
                  </template>
                </b-dropdown>
              </template>
            </b-table>
          </div>
        </div>
      </div>
    </div>
    <ModalDocuments @onSubmitSuccess="handleUpdateItems" ref="documentsModal" />
  </div>
</template>

<script>
import {formatDateTime, humanFileSize} from "@/services/helpers";
import { mapGetters } from "vuex";
import DocumentsService from "@/services/documents.service";
import TableSpiner from "../components/TableSpiner";
import ModalDocuments from "@/components/documents/ModalDocuments";

export default {
  name: "TheDocuments",
  components: {
    TableSpiner,
    ModalDocuments,
  },
  data() {
    return {
      search: "",
      isBusy: false,
      selected: {},
      fields: [
        { key: "name", label: "Nazwa" },
        { key: "size", label: "Rozmiar" },
        { key: "created_at", label: "Dodano" },
        { key: "updated_at", label: "Zmodyfikowano" },
        { key: "download", label: "Pobierz", class: "text-center" },
        { key: "options", label: "Opcje", class: "text-center" },
      ],
      items: false,
    };
  },
  mounted() {
    if (
      this.hasAccess("documentsEdit") === false &&
      this.hasAccess("documentDelete") === false
    ) {
      this.fields.pop();
    }
  },
  computed: {
    ...mapGetters("user", ["isNotSubcontractor", "hasAccess"]),
  },
  filters: {
    date(value) {
      return formatDateTime(value, "YYYY-MM-DD HH:mm");
    }
  },
  methods: {
    getDocuments() {
      if (this.items !== false) {
        return this.items;
      }
      this.$Progress.start();
      return DocumentsService.get()
        .then((items) => {
          this.items = items;
          return this.items;
        })
        .catch(() => {
          return [];
        });
    },
    addDocument() {
      this.$refs.documentsModal.show();
    },
    editDocument(documentIndex) {
      const selected = this.items[documentIndex];
      this.$refs.documentsModal.show(selected);
    },
    handleUpdateItems(newDocument) {
      const updateIndex = this.items.findIndex(
        ({ id }) => id === newDocument.id
      );
      if (updateIndex >= 0) {
        //Update
        this.items[updateIndex] = newDocument;
      } else {
        this.items.push(newDocument);
      }
      this.$refs.documents_table.refresh();
    },
    confirmRemove(documentIndex) {
      const doc = this.items[documentIndex];
      const h = this.$createElement;
      this.$bvModal
        .msgBoxConfirm(
          [
            h("p", [
              "Czy napewno chcesz usunąć plik: ",
              h("strong", doc.name + "." + doc.extension),
              " ?",
            ]),
          ],
          {
            title: "Potwierdź usunięcie pliku",
            okVariant: "danger",
            okTitle: "TAK",
            cancelTitle: "NIE",
          }
        )
        .then((result) => {
          if (result !== true) {
            return;
          }
          this.$Progress.start();
          DocumentsService.remove(doc.id).then(() => {
            this.items.splice(documentIndex, 1);
            this.$refs.documents_table.refresh();
          });
          // this.deleteCategory(item.id);
        });
    },
    download(document) {
      DocumentsService.download(
        document.id,
        document.name + "." + document.extension
      );
    },
    humanFileSize,
  },
};
</script>
